import { Navigate } from 'react-router-dom'
import { Route, RouteParameters } from '../../constants'
import { useAppointment } from 'hooks/useAppointment'
import { useIsSchedulingV2RedirectPending } from '../../hooks'
import { hydratePathname } from 'util/hydratePathname'

export function EditAppointmentWithIntegration({ action }: { action: string }) {
  const { appointment } = useAppointment()
  const isV2RedirectPending = useIsSchedulingV2RedirectPending()

  if (!appointment || isV2RedirectPending) return null

  const pathname = action === 'reschedule' ? Route.APPOINTMENT_RESCHEDULE : Route.APPOINTMENT_CANCELLATION
  const url = new URL(
    hydratePathname(pathname, {
      [RouteParameters.COUNTRY]: appointment.country,
      [RouteParameters.APPOINTMENT_ID]: appointment.id,
    }),
    location.origin
  )
  url.searchParams.set('iframe', 'true')

  return <Navigate to={{ pathname: url.pathname, search: url.search }} replace />
}
